import React from 'react';
import './Events.css';

function Events() {
  const events = [
    {
      date: "June 15, 2025",
      title: "Keystone Opera",
      venue: "어디서 하지??",
      time: "시간??",
      description: "Performing as Contessa in Le nozze di Figaro"
    },
  ];

  return (
    <div className="events-container">
      <h1>Upcoming Events</h1>
      <div className="events-grid">
        {events.map((event, index) => (
          <div key={index} className="event-card">
            <div className="event-date">{event.date}</div>
            <h2>{event.title}</h2>
            <p className="event-venue">{event.venue}</p>
            <p className="event-time">{event.time}</p>
            <p className="event-description">{event.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Events; 